// ✅ VERSION NETTOYÉE : ParticipantsTab sans logs debug
import React, { useEffect } from 'react';
import ParticipantsInterface from '../ParticipantsInterface';

// ✅ IMPORT des styles partagés
import '../../styles/participantsInterface/index.css';

const ParticipantsTab = ({
  // Props de base
  formData,
  setFormData,
  users,
  teams,
  teamLeaders,
  token,
  startDate,
  endDate,
  sessionId,
  editingSession,
  showSuccess,
  showError,
  showWarning,
  showInfo,
  // Props multi-jours
  sessionDays,
  setSessionDays,
  dayParticipants,
  setDayParticipants,
  dayTeamLeaders,
  setDayTeamLeaders,
  participantOnSite,
  setParticipantOnSite,
  getParticipantOnSite,
  setParticipantOnSiteFlag,
  activeDayTab,
  setActiveDayTab,
  multiDayInfo
}) => {
  
  // ✅ PROTECTION : Corriger activeDayTab si hors limites
  const daysCount = sessionDays?.length || multiDayInfo?.days?.length || 0;
  const safeDayTab = Math.min(activeDayTab, Math.max(0, daysCount - 1));
  
  useEffect(() => {
    if (safeDayTab !== activeDayTab && daysCount > 0) {
      // ✅ NETTOYAGE : Suppression log debug
      // console.log(`⚠️ activeDayTab ${activeDayTab} corrigé vers ${safeDayTab} (total jours: ${daysCount})`);
      setActiveDayTab(safeDayTab);
    }
  }, [activeDayTab, safeDayTab, daysCount, setActiveDayTab]);

  // ✅ NETTOYAGE : Suppression monitoring debug sessionDays
  // useEffect(() => {
  //   console.log('🔄 sessionDays a changé dans ParticipantsTab:', sessionDays?.length);
  //   if (sessionDays && sessionDays.length > 0) {
  //     console.log('📋 Nouveaux sessionDays:', sessionDays);
  //   }
  // }, [sessionDays]);

  // ✅ NETTOYAGE : Suppression monitoring debug multiDayInfo
  // useEffect(() => {
  //   console.log('🔄 multiDayInfo a changé dans ParticipantsTab:', multiDayInfo?.days?.length);
  //   if (multiDayInfo?.days && multiDayInfo.days.length > 0) {
  //     console.log('📅 Nouveau multiDayInfo.days:', multiDayInfo.days);
  //   }
  // }, [multiDayInfo]);

  // ✅ NETTOYAGE : Suppression avertissement incohérence et notifications debug
  // if (sessionDays?.length > 0 && multiDayInfo?.days?.length > 0) {
  //   if (sessionDays.length !== multiDayInfo.days.length) {
  //     console.warn('⚠️ INCOHÉRENCE DÉTECTÉE:', {
  //       sessionDays_length: sessionDays.length,
  //       multiDayInfo_days_length: multiDayInfo.days.length,
  //       message: 'sessionDays et multiDayInfo.days ne sont pas synchronisés!'
  //     });
      
  //     // Notification temporaire pour debugging
  //     if (showWarning) {
  //       showWarning(`Incohérence détectée: ${sessionDays.length} sessionDays vs ${multiDayInfo.days.length} multiDayInfo.days`, {
  //         title: '⚠️ Debug synchronisation',
  //         duration: 3000
  //       });
  //     }
  //   }
  // }

  return (
    <div className="participants-tab">
      {/* ✅ EN-TÊTE DE L'ONGLET (style nettoyé) */}
      <div className="sf-tab-header">
        <h3 className="sf-tab-title">
          <span className="sf-tab-icon">👥</span>
          Participants
          {/* ✅ NETTOYAGE : Badge jour simple sans debug */}
          <span style={{
            fontSize: '12px',
            background: '#e9ecef',
            padding: '2px 6px',
            borderRadius: '4px',
            marginLeft: '8px',
            color: '#6c757d'
          }}>
            {daysCount > 1 ? `${daysCount} jours` : '1 jour'}
          </span>
        </h3>
        <div className="sf-tab-subtitle">
          Sélectionnez les participants pour cette formation
        </div>
      </div>

      {/* ✅ VÉRIFICATION DES PRÉREQUIS */}
      {!startDate || !endDate ? (
        <div className="sf-prerequisite-message">
          <div className="sf-prerequisite-icon">⚠️</div>
          <div className="sf-prerequisite-content">
            <h4>Dates de formation requises</h4>
            <p>
              Veuillez d'abord définir les dates de début et fin de la formation 
              dans l'onglet "Informations générales" pour pouvoir sélectionner les participants.
            </p>
          </div>
        </div>
      ) : (
        /* ✅ COMPOSANT PARTICIPANTS INTERFACE - PROPS NETTOYÉES */
        <ParticipantsInterface
          formData={formData}
          setFormData={setFormData}
          users={users}
          teams={teams}
          teamLeaders={teamLeaders || []}
          token={token}
          startDate={startDate}
          endDate={endDate}
          sessionId={sessionId}
          showSuccess={showSuccess}
          showError={showError}
          showWarning={showWarning}
          showInfo={showInfo}
          sessionDays={sessionDays || []}
          setSessionDays={setSessionDays}
          dayParticipants={dayParticipants || {}}
          setDayParticipants={setDayParticipants}
          dayTeamLeaders={dayTeamLeaders || {}}
          setDayTeamLeaders={setDayTeamLeaders}
          participantOnSite={participantOnSite || {}}
          setParticipantOnSite={setParticipantOnSite}
          getParticipantOnSite={getParticipantOnSite}
          setParticipantOnSiteFlag={setParticipantOnSiteFlag}
          activeDayTab={safeDayTab}
          setActiveDayTab={setActiveDayTab}
          multiDayInfo={multiDayInfo}
        />
      )}
    </div>
  );
};

export default ParticipantsTab;